/* Appleseeds storefront behaviour. No dependencies. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var MONTHS = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
  var NOW = new Date().getMonth() + 1;
  function money(c) { var v = (Number(c) / 100).toFixed(2).split('.'); v[0] = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'); return v.join(',') + ' €'; }
  function wrapM(m) { return ((m - 1 + 12) % 12) + 1; }

  /* "Jetzt säen" always follows the visitor's current month (pages may be cached) */
  $$('[data-as-now-month]').forEach(function (el) { el.textContent = MONTHS[NOW - 1]; });
  $$('a[href*="?monat="]').forEach(function (a) { if (/monat=\d+/.test(a.getAttribute('href')) && a.closest('[data-as-now], .as-chips, .as-drawer, .as-404, .as-cartempty, .as-cal__foot')) a.setAttribute('href', a.getAttribute('href').replace(/monat=\d+/, 'monat=' + NOW)); });

  /* toast + count */
  var tt;
  function toast(t) { var el = $('[data-as-toast]'); if (!el) return; $('[data-as-toast-text]', el).textContent = t; el.classList.add('is-show'); clearTimeout(tt); tt = setTimeout(function () { el.classList.remove('is-show'); }, 4000); }
  function refreshCount() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { $$('[data-as-count]').forEach(function (el) { el.textContent = c.item_count; }); }).catch(function () {});
  }

  /* AJAX add */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.classList || !f.classList.contains('as-addform') || !window.fetch) return;
    e.preventDefault();
    var btn = e.submitter || $('[type=submit]', f) || document.querySelector('[form="' + f.id + '"]');
    if (btn) btn.classList.add('is-loading');
    var data = new FormData(f);
    if (!(parseInt(data.get('quantity') || '1', 10) > 0)) data.set('quantity', '1');
    fetch(root + 'cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (btn) btn.classList.remove('is-loading');
        if (!res.ok) { toast(res.j.description || 'Das hat nicht geklappt.'); return; }
        toast('Im Korb: ' + (res.j.product_title || 'Artikel'));
        if (btn && btn.classList.contains('as-sq')) { btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 1600); }
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        refreshCount();
      })
      .catch(function () { if (btn) btn.classList.remove('is-loading'); f.submit(); });
  });

  /* drawer + mobile search + cookie */
  var drawer = $('[data-as-drawer]');
  function setDrawer(o) { if (!drawer) return; drawer.classList.toggle('is-open', o); document.documentElement.style.overflow = o ? 'hidden' : ''; var b = $('[data-as-drawer-open]'); if (b) b.setAttribute('aria-expanded', o ? 'true' : 'false'); }
  $$('[data-as-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(true); }); });
  $$('[data-as-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(false); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setDrawer(false); });
  $$('[data-as-search-toggle]').forEach(function (b) { b.addEventListener('click', function () { var s = $('[data-as-search]'); if (!s) return; s.classList.toggle('is-open'); if (s.classList.contains('is-open')) { var i = $('input[type=search]', s); if (i) i.focus(); } }); });
  $$('[data-as-cookie]').forEach(function (b) { b.addEventListener('click', function () { if (window.privacyBanner && window.privacyBanner.showPreferences) window.privacyBanner.showPreferences(); else window.location.href = root + 'pages/datenschutz'; }); });

  /* tabs (home) */
  $$('[data-as-tabs]').forEach(function (w) {
    var tabs = $$('[role=tab]', w);
    tabs.forEach(function (t) { t.addEventListener('click', function () {
      tabs.forEach(function (x) { var on = x === t; x.setAttribute('aria-selected', on ? 'true' : 'false'); var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on; });
    }); });
  });

  /* Saatregal: month switcher + 4-up carousel */
  $$('[data-as-rack]').forEach(function (rack) {
    var cards = $$('.as-packet', rack), cont = $('[data-as-rack-cards]', rack), empty = $('[data-as-rack-empty]', rack);
    var tabsEl = $('[data-as-month-tabs]', rack), count = $('[data-as-rack-count]', rack);
    var prev = $('[data-as-rack-prev]', rack), next = $('[data-as-rack-next]', rack), all = $('[data-as-rack-all]', rack);
    var month = NOW, page = 0, per = function () { return window.innerWidth < 1024 ? 2 : 4; }, list = [];
    [wrapM(NOW - 1), NOW, wrapM(NOW + 1)].forEach(function (m) {
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('role', 'tab'); b.textContent = MONTHS[m - 1]; b.dataset.m = m;
      b.setAttribute('aria-selected', m === NOW ? 'true' : 'false');
      b.addEventListener('click', function () { month = m; page = 0; $$('button', tabsEl).forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); }); render(); });
      tabsEl.appendChild(b);
    });
    function render() {
      list = cards.filter(function (c) { return c.dataset.months.indexOf(',' + month + ',') > -1; });
      // outdoor sowing first, then indoor
      list.sort(function (a, b) { return (b.dataset.aus.indexOf(',' + month + ',') > -1) - (a.dataset.aus.indexOf(',' + month + ',') > -1); });
      var n = per(), pages = Math.max(1, Math.ceil(list.length / n));
      if (page >= pages) page = pages - 1;
      cards.forEach(function (c) { c.hidden = true; });
      list.slice(page * n, page * n + n).forEach(function (c) { cont.insertBefore(c, empty); c.hidden = false; });
      empty.hidden = list.length > 0;
      var from = list.length ? page * n + 1 : 0, to = Math.min(list.length, page * n + n);
      count.textContent = from + '–' + to + ' von ' + list.length + ' Sorten für ' + MONTHS[month - 1];
      prev.disabled = page === 0; next.disabled = page >= pages - 1;
      $$('[data-as-rack-month]', rack).forEach(function (el) { el.textContent = MONTHS[month - 1]; });
      if (all) { all.href = root + 'collections/all?monat=' + month; all.firstChild.textContent = 'Alle ' + list.length + ' Sorten für '; }
    }
    prev.addEventListener('click', function () { page--; render(); });
    next.addEventListener('click', function () { page++; render(); });
    window.addEventListener('resize', function () { render(); });
    render();
  });

  /* collection filters (client-side, on packet data attributes) */
  var col = $('[data-as-col]');
  if (col) {
    var grid = $('[data-as-col-grid]', col), packets = $$('.as-packet', grid), promo = $('[data-as-promo]', grid), emptyC = $('[data-as-col-empty]', col);
    var countC = $('[data-as-col-count]', col), chips = $('[data-as-col-chips]', col), sortSel = $('[data-as-col-sort]', col);
    var state = { months: [], mode: '', flags: [] };
    var q = new URLSearchParams(window.location.search);
    if (q.get('monat')) state.months = [parseInt(q.get('monat'), 10)].filter(function (m) { return m >= 1 && m <= 12; });
    var original = packets.slice();
    function match(p) {
      if (state.months.length) {
        var src = state.mode === 'vor' ? p.dataset.vor : state.mode === 'aus' ? p.dataset.aus : p.dataset.months;
        if (!state.months.some(function (m) { return src.indexOf(',' + m + ',') > -1; })) return false;
      } else if (state.mode) {
        if ((state.mode === 'vor' ? p.dataset.vor : p.dataset.aus) === ',') return false;
      }
      return state.flags.every(function (f) {
        if (f === 'samenfest') return p.dataset.samenfest === 'true';
        if (f === 'alt') return p.dataset.alt === 'true';
        if (f.indexOf('tag:') === 0) return (',' + p.dataset.tags + ',').indexOf(',' + f.slice(4) + ',') > -1;
        return true;
      });
    }
    function apply() {
      var shown = 0;
      packets.forEach(function (p) { var ok = match(p); p.hidden = !ok; if (ok) shown++; });
      if (promo) promo.hidden = state.months.length > 0 || state.flags.length > 0 || state.mode !== '';
      emptyC.hidden = shown > 0;
      countC.textContent = shown + ' Artikel';
      chips.innerHTML = '';
      var labels = { samenfest: 'Samenfest', alt: 'Alte Sorte', 'tag:balkon': 'Balkon & Kübel', 'tag:einsteiger': 'Einsteiger', 'tag:bienen': 'Bienenfreundlich' };
      state.months.forEach(function (m) { addChip('Aussaat: ' + MONTHS[m - 1], function () { state.months = state.months.filter(function (x) { return x !== m; }); sync(); }); });
      if (state.mode) addChip(state.mode === 'vor' ? 'Vorziehen' : 'Direkt säen', function () { state.mode = ''; sync(); });
      state.flags.forEach(function (f) { addChip(labels[f] || f, function () { state.flags = state.flags.filter(function (x) { return x !== f; }); sync(); }); });
      if (state.months.length || state.flags.length || state.mode) { var c = document.createElement('button'); c.type = 'button'; c.className = 'as-clear'; c.textContent = 'Alle entfernen'; c.addEventListener('click', reset); chips.appendChild(c); }
      var url = new URL(window.location.href);
      if (state.months.length === 1) url.searchParams.set('monat', state.months[0]); else url.searchParams.delete('monat');
      window.history.replaceState({}, '', url.toString());
    }
    function addChip(text, fn) { var b = document.createElement('button'); b.type = 'button'; b.className = 'as-active'; b.innerHTML = text + ' <span aria-hidden="true">×</span>'; b.setAttribute('aria-label', text + ' entfernen'); b.addEventListener('click', fn); chips.appendChild(b); chips.appendChild(document.createTextNode(' ')); }
    function sync() {
      $$('[data-as-f-months] button', col).forEach(function (b) { b.setAttribute('aria-pressed', state.months.indexOf(+b.dataset.m) > -1 ? 'true' : 'false'); });
      $$('[data-as-f-mode] button', col).forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.mode === state.mode ? 'true' : 'false'); });
      $$('[data-as-f]', col).forEach(function (i) { i.checked = state.flags.indexOf(i.dataset.asF) > -1; });
      apply();
    }
    function reset() { state = { months: [], mode: '', flags: [] }; sync(); }
    $$('[data-as-f-months] button', col).forEach(function (b) { b.addEventListener('click', function () { var m = +b.dataset.m, i = state.months.indexOf(m); if (i > -1) state.months.splice(i, 1); else state.months.push(m); sync(); }); });
    $$('[data-as-f-mode] button', col).forEach(function (b) { b.addEventListener('click', function () { state.mode = b.dataset.mode; sync(); }); });
    $$('[data-as-f]', col).forEach(function (i) { i.addEventListener('change', function () { var f = i.dataset.asF; if (i.checked) state.flags.push(f); else state.flags = state.flags.filter(function (x) { return x !== f; }); sync(); }); });
    var rs = $('[data-as-col-reset]', col); if (rs) rs.addEventListener('click', reset);
    sortSel.addEventListener('change', function () {
      var v = sortSel.value, arr = original.slice();
      if (v === 'price-asc') arr.sort(function (a, b) { return a.dataset.price - b.dataset.price; });
      if (v === 'price-desc') arr.sort(function (a, b) { return b.dataset.price - a.dataset.price; });
      if (v === 'title') arr.sort(function (a, b) { return a.dataset.title.localeCompare(b.dataset.title, 'de'); });
      arr.forEach(function (p) { grid.insertBefore(p, emptyC); });
      if (promo && arr[3]) grid.insertBefore(promo, arr[4] || emptyC);
    });
    var ft = $('[data-as-filter-toggle]', col), fl = $('[data-as-filters]', col);
    if (ft) ft.addEventListener('click', function () { var o = fl.classList.toggle('is-open'); ft.setAttribute('aria-expanded', o ? 'true' : 'false'); });
    sync();
  }

  /* full calendar page: group + month filter */
  $$('[data-as-cal]').forEach(function (cal) {
    var bar = $('[data-as-cal-groups]', cal); if (!bar) return;
    var rows = $$('tbody tr', cal);
    $$('button', bar).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('button', bar).forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
        rows.forEach(function (r) {
          var ok = true;
          if (b.dataset.group) ok = r.dataset.group === b.dataset.group;
          if (b.dataset.month) ok = r.dataset.months.indexOf(',' + NOW + ',') > -1;
          r.hidden = !ok;
        });
      });
    });
  });

  /* product page */
  var pdp = $('[data-as-product]');
  if (pdp) {
    var idIn = $('[data-as-variant]', pdp), qty = $('[data-as-qty]', pdp);
    $$('input[name="as-v"]', pdp).forEach(function (r) {
      r.addEventListener('change', function () {
        idIn.value = r.value;
        $$('[data-as-price], [data-as-sticky-price]').forEach(function (el) { el.textContent = money(r.dataset.price); });
        var ul = $('[data-as-unitline]', pdp); if (ul) ul.textContent = r.dataset.unit;
        var sv = $('[data-as-sticky-var]'); if (sv) sv.textContent = r.closest('.as-var').querySelector('b').textContent + ' · inkl. MwSt.';
        var url = new URL(window.location.href); url.searchParams.set('variant', r.value); window.history.replaceState({}, '', url.toString());
      });
    });
    $$('[data-as-qty-step]', pdp).forEach(function (b) { b.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(b.dataset.asQtyStep)); }); });
    var slides = $$('[data-as-slide]', pdp), thumbs = $$('[data-as-thumb]', pdp);
    thumbs.forEach(function (t) { t.addEventListener('click', function () { var i = +t.dataset.asThumb; slides.forEach(function (s, j) { s.hidden = j !== i; }); thumbs.forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); }); }); });
  }

  /* cart */
  var cart = $('[data-as-cart]');
  if (cart) {
    var t2;
    function soon() { clearTimeout(t2); t2 = setTimeout(function () { cart.submit(); }, 450); }
    $$('[data-as-step]', cart).forEach(function (b) { b.addEventListener('click', function () { var i = $('[data-as-line-qty]', b.parentNode); i.value = Math.max(0, (parseInt(i.value, 10) || 0) + Number(b.dataset.asStep)); soon(); }); });
    $$('[data-as-line-qty]', cart).forEach(function (i) { i.addEventListener('change', soon); });
    var note = $('#as-note');
    if (note) note.addEventListener('change', function () { fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) }).catch(function () {}); });
    var cb = $('[data-as-coupon-apply]'), ci = $('[data-as-coupon]');
    function apply() { var c = (ci.value || '').trim(); if (!c) { ci.focus(); return; } window.location.href = root + 'discount/' + encodeURIComponent(c) + '?redirect=' + encodeURIComponent(root + 'cart'); }
    if (cb) { cb.addEventListener('click', apply); ci.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); apply(); } }); }
  }
})();
